// extracted by mini-css-extract-plugin
export default {"container":"specs-table__container___24E39","label":"specs-table__label___3N68H","utqg-tooltip":"specs-table__utqg-tooltip___Mec8u","overview":"specs-table__overview___3d0hr"};